import React, { useEffect, useState } from "react";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import AppBarTop from '../MainBars/AppBar';
import MainContent from './MainContent';
import ArticleIcon from '@mui/icons-material/Article';
import InfoIcon from '@mui/icons-material/Info';
import ForumIcon from '@mui/icons-material/Forum';
import Footer from "../../components/Footer";
import { facade } from "../../helpers/analytic/AnalyticFacade";
import { MenuPageEvent } from "../../helpers/analytic/event/MenuPageEvent";
import { PageLoadedEvent } from "../../helpers/analytic/event/PageLoadedEvent";
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import { signUp } from '../../commands/user/signUp';
import { bs58 } from '@project-serum/anchor/dist/cjs/utils/bytes';
import { saveWalletAddress, updateQuestsLs, getQuestsLs, getWalletAddress } from "../../commands/localStoreCommand";
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import QuestConfig from "../Pages/Quests/QuestConfig.json";
import { useRouter } from 'next/router';
import { APIResult } from "../../commands/APIResult";
import WorkIcon from '@mui/icons-material/Work';
import { getDragonsData } from "../../commands/mint/getDragons";
import { GetMintRes, getWhitelist } from "../../commands/mint/getWhitelist"
import { getPublicMint, GetPublicMintRes } from "../../commands/mint/getPublicMint"
import CollectionsIcon from '@mui/icons-material/Collections';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import StarIcon from '@mui/icons-material/Star';
import { IDragon } from "../../helpers/interfaces/dragon"

//
declare global {
    interface Window {
        solana: any;
    }
}

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

//
const SOCIAL_URLS: any = {
    medium: "https://eternaldragons.medium.com/",
    discord: "https://discord.gg/eternaldragons",
    twitter: "https://twitter.com/EternalDragons_"
}

//
type MainPageProps = {
    page: string,
    dragon?: IDragon, // We get this dragon from DragonDetails Page getServerSideProps!
    addressDragons?: IDragon[] // dragons from /gallery/[userAddress]
}

//
export interface IIdentity {
    address: string;
    email: string;
    twitterAnchor: string;
    discordAnchor: string;
}

export default function MainUI(props: MainPageProps) {

    const theme = useTheme();
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const [mainMenuValue, setMainMenuValue] = React.useState('home');
    const { connected, wallets, wallet: selected, publicKey, signMessage } = useWallet();
    const [quests, setQuests] = React.useState({ quests: [QuestConfig[0]], points: 0 });
    const [celebrateQuests, setCelebrateQuests] = React.useState(false);
    const router = useRouter();

    // Dragons for conected wallet user!
    const [myDragons, setMyDragons] = React.useState<any>([]);
    const [myDragonsLoadedFor, setMyDragonsLoadedFor] = useState<string>('');

    // Dragons for /gallery/[userAdress] user address! 
    const [addressDragons, setAddressDragons] = React.useState<any>([]);

    const [reloadDragonsInProg, setReloadDragonsInProg] = React.useState<boolean>(false);

    //FiXME: Seems to hold same data as userPublicData
    const [userWhitelistData, setUserWhitelistData] = useState<GetMintRes>();
    const [wlDataLoadedForAddress, setWlDataLoadedForAddress] = useState<string>('');

    const [userPublicData, setPublicUserData] = useState<GetPublicMintRes>();
    const [publicDataLoadedForAddress, setPublicDataLoadedForAddress] = useState<string>('');

    const [user, setUser] = useState<IIdentity | null>(null);

    // Set address dragons
    useEffect(() => {
        if (props.addressDragons) {
            setAddressDragons(props.addressDragons);
        }
    }, [props.addressDragons]);

    //FiX ME: This should be part of a page loading https://nextjs.org/docs/basic-features/pages
    async function loadUserWhitelistInfData(address: string, force: boolean) {

        if (wlDataLoadedForAddress !== address || force === true) {
            let res: GetMintRes = await getWhitelist(address);

            console.log("WL status ", res)
            if (res.status >= 0) {

                if (res.status === 1 && res.countdown_timer) {
                    // We have counter for 'allocate mint spots'!
                    res.future_countdownTimer = new Date(Date.now() + res.countdown_timer + 1000);
                }

                else if (res.status === 0) {
                    if (res.curBatchInfo) { // null means that mint over for all batches!
                        if (res.curBatchInfo.type === 'waiting_mint_batch' && res.curBatchInfo && res.curBatchInfo.mintStartInMs) {
                            res.future_countdownTimer = new Date(Date.now() + res.curBatchInfo.mintStartInMs + 1000);
                        }
                        else if (res.curBatchInfo.type === 'during_mint_batch' && res.curBatchInfo && res.curBatchInfo.mintEndInMs) {
                            res.future_countdownTimer = new Date(Date.now() + res.curBatchInfo.mintEndInMs + 1000);
                        }
                    }
                }

                // So we know that data is loaded - and we dont reload!
                setWlDataLoadedForAddress(address);
            }

            setUserWhitelistData(res);
        }
    }

    //FiX ME: This should be part of a page loading https://nextjs.org/docs/basic-features/pages
    async function loadUserPublicInfoData(address: string, force: boolean) {

        if (publicDataLoadedForAddress !== address || force === true) {
            let res: GetPublicMintRes = await getPublicMint(address);

            //FIX ME: futur counter is not part of GetPublicMintRes
            if (res.status >= 0) {

                //FIX ME DUPLICATE LOGIC 
                if (res.status === 1 && res.curBatchInfo && res.curBatchInfo.mintStartInMs) {
                    res.future_countdownTimer = new Date(Date.now() + res.curBatchInfo.mintStartInMs + 1000);
                }
                else if (res.status === 0 && res.curBatchInfo && res.curBatchInfo.mintEndInMs) {
                    res.future_countdownTimer = new Date(Date.now() + res.curBatchInfo.mintEndInMs + 1000);
                }

                // So we know that data is loaded - and we dont reload!
                setPublicDataLoadedForAddress(address);
            }

            setPublicUserData(res);
        }
    }

    //
    function updateQuests(res: APIResult, celebrate: boolean) {
        updateQuestsLs(res);
        loadQuests();

        if (celebrate === true) {
            setCelebrateQuests(true);
            setTimeout(() => { setCelebrateQuests(false); }, 3500); // reset!
        }
    }

    function loadQuests() {
        let quests = getQuestsLs();

        if (quests) {
            setQuests(quests);
        }
    }

    const handleDrawerOpen = () => {
        setOpenDrawer(true);
    };

    const handleMainMenuChange = (event: React.SyntheticEvent, newValue: string) => {

        facade.sendEvent(new MenuPageEvent(newValue));

        setMainMenuValue(newValue);
    };

    useEffect(() => {
        facade.sendEvent(new PageLoadedEvent(props.page));
    }, [props.page]);


/*   useEffect(() => {
        // Load quests from LS first - just in case!
        loadQuests();

        if (publicKey) {
            const base58 = publicKey.toBase58();
            const keyToDisplay =
                base58.length > 20
                    ? `${base58.substring(0, 7)}.....${base58.substring(
                        base58.length - 7,
                        base58.length,
                    )}`
                    : base58;


            facade.setUserAddress(base58);

            //  setKey(keyToDisplay)
            if (signMessage) {

                const encodedMessage = new TextEncoder().encode("Welcome to Eternal Dragons");

                signMessage(encodedMessage).then(signature => {
                    signUp(base58, bs58.encode(signature)).then(res => {
                        console.log("update Quest", res)
                        saveWalletAddress(publicKey);
                        updateQuests(res, res.status === 0);
                        setUser(res.data.identity);
                    });
                }).catch(e => {
                    console.log(e);
                });

            }

        }
    }, [publicKey, signMessage]);*/


    //
    useEffect(() => {
        if (router.query.celebrate === "true") {
            setCelebrateQuests(true);
            setTimeout(() => { setCelebrateQuests(false); }, 3500); // reset!

            // Remove celebrate query string!
            router.replace(router.pathname);
        }
    }, [router]);

    //
    async function reloadMyDragons(walletAddress: string, showLoading: boolean, force: boolean) {

        // Load only if forced or wallet address changed!
        if (!force && walletAddress === myDragonsLoadedFor) {
            return;
        }

        if (showLoading) {
            setReloadDragonsInProg(true);
        }

        let data = await getDragonsData(walletAddress);

        if (data.status >= 0) {
            setMyDragons(data.nftList);
            setMyDragonsLoadedFor(walletAddress);
        }
        else {
            setMyDragons([]);
            setMyDragonsLoadedFor("");
        }

        setReloadDragonsInProg(false);
    }

    // When user finish twitter quest we just update twitter in user identity onject - no need for request ti backend!
    function setUserTwitter(twUserName: string) {
        if (user) {
            setUser((prevState: any) => {
                return {
                    email: prevState.email,
                    discordAnchor: prevState.discordAnchor,
                    address: prevState.address,
                    twitterAnchor: twUserName // Update!!
                }
            })
        }
    }

    //
    const menuOpts = [
        { id: "whitepaper", label: "Whitepaper", icon: <ArticleIcon />, walletConnected: false, link: "/whitepaper" },
        //{ id: "whitepaper", label: "Whitepaper", icon: <ArticleIcon />, walletConnected: false },
        { id: "about_us", label: 'About Us', icon: <InfoIcon />, walletConnected: false, link: "/#team" },
        { id: "community", label: "Community", icon: <ForumIcon />, walletConnected: false },
        //{ id: "candy_machine", label: "Mint NFT!", icon: <PrecisionManufacturingIcon />, walletConnected: true },
        //{ id: "inventory", label: "Inventory", icon: <InventoryIcon />, walletConnected: true },
        //{ id: "dashboard", label: "Dashboard", icon: <InventoryIcon />, walletConnected: true },
        { id: "marketplace", label: "Marketplace", icon: <LocalGroceryStoreIcon />, walletConnected: false, link: "https://magiceden.io/marketplace/eternal_dragons_genesis" },
        { id: "my_gallery", label: "Gallery", icon: <CollectionsIcon />, walletConnected: false, link: "/mygallery" },
        { id: "ranking", label: "Ranking", icon: <StarIcon />, walletConnected: false, link: "/ranking" }
    ].filter((el: any) => el.walletConnected === false || (el.walletConnected === true && connected));;


    //
    return (
        <Box>
            <Box sx={{ display: 'flex', background: "white", width: "100%" }}>
                <CssBaseline />

                {/* Top main menu */}
                <AppBarTop
                    openDrawer={openDrawer}
                    handleDrawerOpen={handleDrawerOpen}
                    mainMenuValue={mainMenuValue}
                    handleMainMenuChange={handleMainMenuChange}
                    socialUrls={SOCIAL_URLS}
                    menuOpts={menuOpts}
                />

                <Box className="main-tb" sx={{ flexGrow: 1, p: 3, background: "white", color: "#c1d7ea", marginBottom: 0, position: 'relative', padding: "0px" }} >
                    {/*<DrawerHeader />*/}

                    {/* Main display area */}
                    <MainContent
                        page={props.page}
                        socialUrls={SOCIAL_URLS}
                        quests={quests}
                        updateQuests={updateQuests}
                        celebrateQuests={celebrateQuests}
                        myDragons={myDragons}
                        addressDragons={addressDragons}
                        reloadMyDragons={reloadMyDragons}
                        reloadDragonsInProg={reloadDragonsInProg}
                        userWhitelistData={userWhitelistData}
                        loadUserWhitelistInfData={loadUserWhitelistInfData}
                        publicData={userPublicData}
                        loadUserPublicInfoData={loadUserPublicInfoData}
                        dragon={props.dragon}
                        user={user}
                        setUserTwitter={setUserTwitter}
                    />
                </Box>
            </Box>

            {/* Footer */}
            <Footer socialUrls={SOCIAL_URLS} />
        </Box>
    );
}
